import { render, staticRenderFns } from "./CardData.vue?vue&type=template&id=d8c4e048&scoped=true&"
import script from "./CardData.vue?vue&type=script&lang=js&"
export * from "./CardData.vue?vue&type=script&lang=js&"
import style0 from "./CardData.vue?vue&type=style&index=0&id=d8c4e048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c4e048",
  null
  
)

export default component.exports